import React from 'react';
import { Link } from 'react-router-dom'
import PicturePreview from './../PicturePreview';
import { setSelfieVideo, setIdCardImage, setIdCardImageBack, setCheckinCurrentPageName } from '../../../action/autoCheckin';
import { connect } from 'react-redux';
import closeIcon from '../../../images/icons/close_icon.svg';
import { setGoHome } from '../../../action/homeAction'
import Camera from './../Camera';
import { mobileCheckinColorConfig } from '../../../JS/colorConfig';
import LivelinessTip from './../livelinessTip'
import { withTranslation } from 'react-i18next'
import { getDefaultAnalyticsLabel } from '../../../JS/utility';
import { sendAnalytics } from '../../../../action/homeAction';
import { CMSPath } from '../../../../config/constant';
import { Arrow_svg, Cross_svg, Tick_svg } from './index';

// import { setSelfieVideo } from '../../../action/autoCheckin';

class SelfieCapture extends React.Component {
  constructor(props) {
    super(props)
    this.state = {

    }
  }

  componentDidUpdate(prevProps, prevState) {
    mobileCheckinColorConfig(this.props.menuColor);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    mobileCheckinColorConfig(this.props.menuColor);
  }

  handleSelfieClick = () => {
    this.props.setShowCameraPrevForSelfie()
  }

  render() {
    const { t } = this.props
    return (

      <div class={`selfie-verification ${!this.props.selfieVideo && this.props.idCardImage && ((this.props.selectedIdType && this.props.selectedIdType.bothSideImageRequired ? this.props.idCardImageBack : true) ? "current-focus" : "")}`}
        onClick={this.handleSelfieClick}
      >
        <div class={`icon-status ${this.props.selfieVideo ? "complete" : "incomplete"}`}>
          {this.props.selfieVideo ? <Tick_svg /> : <Cross_svg />}
        </div>

        <div class="text">
          <div class="heading">
          {t('pre_checkIn.identity_verification_selfie_heading', { defaultValue: 'Take a selfie' })}
          </div>
          <div class="subheading">
          {t('pre_checkIn.identity_verification_selfie_subheading', { defaultValue: 'Remove all objects that may obscure your identity.' })}
          </div>
        </div>
        <div class="arrow-sign">
          <Arrow_svg />
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    selfieVideo: state.store2.selfieVideo,
    menuColor: state.store.home.MenuColor,
    selectedIdType: state.store2.selectedIdType,
    logo: state.store.home.currentDuration.brandingInfo ?
      state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
    currentWidgetObj: state.store.sideNavBar.currentWidget,
    guestDetail: state.store.home.guestDetails,
    guestIsLoggedIn: state.store2.guestIsLoggedIn,
    installedAppVersion: state.store.installedAppVersion,
    installedAppBuildNo: state.store.installedAppBuildNo,
    currentHomePage: state.store2.currentHomePage,
    idCardImage: state.store2.idCardImage,
    idCardImageBack: state.store2.idCardImageBack,
  }
}

export default connect(mapStateToProps, { setSelfieVideo, setGoHome, setIdCardImage, setIdCardImageBack, sendAnalytics, setCheckinCurrentPageName })(withTranslation('translations')(SelfieCapture));